module.exports = __webpack_public_path__ + "img/44.9b71e3b9.png";